<div class="pt-100">
    <div class="tab__content">
        <div class="row mt-3 ">
            <div class="col-md-12">
                <div class="vertical-tab" role="tabpanel">
                    <div class="row">
                        <!-- Left Column: Post Job Tab -->
                        <!--<div class="col-md-3 d-flex flex-column justify-content-start">
                            <div class="nav flex-column nav-tabs border" role="tablist" aria-orientation="vertical">
                                <a class="nav-link active border post-job-tab border-0"
                                   [class.active]="selecttab === 'pendingDetail'"
                                   (click)="switchTab1('pendingDetail')"
                                   role="tab" data-bs-toggle="tab">Pending</a>
                                <a class="nav-link text-start border-0  mb-0"
                                   [class.active]="selecttab === 'selectedDetail'"
                                   (click)="switchTab1('selectedDetail')"
                                   role="tab"
                                   data-bs-toggle="tab">Selected List</a>
                                <a class="nav-link text-start mt-0 border-top-0 border-bottom "
                                   [class.active]="selecttab === 'rejectDetail'"
                                   (click)="switchTab1('rejectDetail')"
                                   role="tab"
                                   data-bs-toggle="tab">Rejected</a>-->
                                <!-- Add more tabs as needed -->
                            <!--</div>
                        </div>-->
                        <!-- manage job start-->
                        <div class="col-12 small-screen mb-3">
                            <div role="tabpanel" class="tab-pane fade show"
                                 [class.active]="selecttab === 'pendingDetail'"
                                 *ngIf="selecttab === 'pendingDetail'" id="pendingDetail">

                                <h5 class="headd">Pending Candidates</h5><hr>


                                <div class="container">
                                    <div class="row">

                                        <div class="col-lg-12 " *ngFor="let candidate of jobdata">
                                            <div class="card candidate-card mb-4">

                                                <div class="card-body">
                                                    <div class="card-title" style="color: #265ac3;">
                                                        <span class="d-flex justify-content-between">
                                                            <div class="d-flex">
                                                                <img *ngIf="candidate.Photo; else personIcon"
                                                                     [src]="HomeURL + candidate.Photo"
                                                                     style="width: 45px; height: 45px; border-radius: 50%; object-fit: cover; margin-right: 8px;">

                                                                <ng-template #personIcon>
                                                                    <i class="fas fa-user" style="color: black;"></i>
                                                                </ng-template>
                                                                {{ candidate.FirstName }}
                                                            </div>
                                                            <a (click)="DeleteCadidates(candidate.JID)">
                                                                <i class="fa-solid fa-trash-can" style=" color: darkred;"></i>
                                                            </a>
                                                        </span>
                                                    </div>

                                                    <br />



                                                    <h6 class="card-subtitle mb-2 text-muted">
                                                        <i class="fas fa-briefcase"></i> {{ candidate.Designation }}
                                                    </h6>

                                                    <div class="card-links  d-flex gap-1">

                                                        <a (click)="downloadResume($event,candidate)"
                                                           class="btn btn-primary ">
                                                            <i class="fas fa-file-download"></i> View
                                                        </a>
                                                        <a *ngIf="HomeURL + candidate.AudioRecord" class="btn btn-info btn-sm" (click)="playAudio(candidate)">
                                                            <i class="fas fa-microphone"></i>Audio
                                                        </a>

                                                        <!-- Video Preview Button -->
                                                        <a *ngIf="HomeURL + candidate.VideoRecord" class="btn btn-secondary btn-sm" (click)="playVideo(candidate)">
                                                            <i class="fas fa-video"></i> Video
                                                        </a>

                                                        <button type="button" class="btn btn-success btn-sm select-btn" (click)="UpdatestatusSelect(candidate)">
                                                            <i class="fas fa-check"></i> Select
                                                        </button>
                                                        <button type="button" class="btn btn-danger btn-sm reject-btn" (click)="UpdatestatusReject(candidate)">
                                                            <i class="fas fa-times"></i> Reject
                                                        </button>




                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>

                            <!-- manage job end -->
                            <div class="col-12 small-screen w-100">
                                <div role="tabpanel" class="tab-pane fade show"
                                     [class.active]="selecttab === 'selectedDetail'"
                                     *ngIf="selecttab === 'selectedDetail'" id="selectedDetail">

                                    <h5  class="headd">Selected Candidates</h5><hr />
                                    <div class="container-fluid">

                                        <div class="row">
                                            <div class="col-lg-12 " *ngFor="let candidate of Sjobdata">

                                                <div class="card candidate-card mb-4">
                                                    <div class="card-body">


                                                        <div class="card-title" style="color: #265ac3;">
                                                            <span class="d-flex justify-content-between">
                                                                <div class="d-flex">
                                                                    <!--<img *ngIf="candidate.Photo; else personIcon"
                                                                         [src]="candidate.Photo"
                                                                         style="width: 45px; height: 45px; border-radius: 50%; object-fit: cover; margin-right: 8px;">-->
                                                                    <img *ngIf="candidate.Photo; else personIcon"
                                                                         [src]="HomeURL + candidate.Photo"
                                                                         style="width: 45px; height: 45px; border-radius: 50%; object-fit: cover; margin-right: 8px;">

                                                                    <ng-template #personIcon>
                                                                        <i class="fas fa-user" style="color: black;"></i>
                                                                    </ng-template>
                                                                    {{ candidate.FirstName }}
                                                                </div>
                                                                <a (click)="DeleteCadidates(candidate.JID)">
                                                                    <i class="fa-solid fa-trash-can" style=" color: darkred;"></i>
                                                                </a>
                                                            </span>
                                                        </div> 
                                                        <!--<h5 class="card-title" style="color: #265ac3; margin-top: -36px;">
                                                            <a (click)="DeleteCadidates(candidate.JID)">
                                                                <i class="fa-solid fa-trash-can" style="margin-left: 100%; color: darkred;"></i>
                                                            </a>
                                                            <img *ngIf="candidate.Photo; else personIcon"
                                                                 [src]="candidate.Photo"
                                                                 style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 8px;">
                                                            <ng-template #personIcon>
                                                                <i class="fas fa-user" style="color: black; margin-right: 8px;"></i>
                                                            </ng-template>
                                                            {{ candidate.FirstName }}
                                                        </h5>--><br />
                                                        <h6 class="card-subtitle mb-2 text-muted">

                                                            <i class="fas fa-briefcase"></i> {{ candidate.Designation }}
                                                        </h6>
                                                        <!--<p class="card-text">
        <i class="fas fa-envelope"></i> <strong>Email:</strong> {{ candidate.Email }}<br>
        <i class="fas fa-graduation-cap"></i> <strong>Qualification:</strong> {{ candidate.Qualification }}<br>
        <i class="fas fa-tools"></i> <strong>Key Skills:</strong> {{ candidate.KeySkills }}<br>
        <i class="fas fa-map-marker-alt"></i> <strong>Current Location:</strong> {{ candidate.CurrentWorkLocation }}<br>
        <i class="fas fa-briefcase"></i> <strong>Experience:</strong> {{ candidate.Experience || 'Not defined' }} years<br>
        <i class="fas fa-money-bill-wave"></i> <strong>Salary:</strong> ₹{{ candidate.Salary || 'Not defined' }}<br>
        <i class="fas fa-hand-holding-usd"></i> <strong>Expected Salary:</strong> ₹{{ candidate.EexpectingSalary || 'Not defined' }}
    </p>-->

                                                        <div class="card-links">

                                                            <!-- Resume Download Button -->

                                                            <a (click)="downloadResume($event,candidate)"
                                                               class="btn btn-primary btn-sm">
                                                                <i class="fas fa-file-download"></i> View
                                                            </a>
                                                            <a *ngIf="HomeURL + candidate.AudioRecord" class="btn btn-info btn-sm" (click)="playAudio(candidate)">
                                                                <i class="fas fa-microphone"></i>Audio
                                                            </a>

                                                            <!-- Video Preview Button -->
                                                            <a *ngIf="HomeURL + candidate.VideoRecord" class="btn btn-secondary btn-sm" (click)="playVideo(candidate)">
                                                                <i class="fas fa-video"></i> Video
                                                            </a>
                                                            <button type="button" class="btn btn-success btn-sm select-btn">
                                                                <i class="fas fa-check"></i> Selected
                                                            </button>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div class="col-12 small-screen mb-3 w-100 ">
                                <div role="tabpanel" class="tab-pane fade show"
                                     [class.active]="selecttab === 'rejectDetail'"
                                     *ngIf="selecttab === 'rejectDetail'" id="rejectDetail">
                                    <h5  class="headd">Rejected Candidates</h5><hr />
                                    <div class="container">
                                        <div class="row">
                                            <div class="col-lg-12 m-0 " *ngFor="let candidate of Rjobdata">
                                                <div class="card candidate-card mb-4">
                                                    <div class="card-body"> 
                                                        <div class="card-title" style="color: #265ac3;">
                                                            <span class="d-flex justify-content-between">
                                                                <div class="d-flex">
                                                                    <!--<img *ngIf="candidate.Photo; else personIcon"
    [src]="candidate.Photo"
            style="width: 45px; height: 45px; border-radius: 50%; object-fit: cover; margin-right: 8px;">-->
                                                                    <img *ngIf="candidate.Photo; else personIcon"
                                                                         [src]="HomeURL + candidate.Photo"
                                                                         style="width: 45px; height: 45px; border-radius: 50%; object-fit: cover; margin-right: 8px;">

                                                                    <ng-template #personIcon>
                                                                        <i class="fas fa-user" style="color: black;"></i>
                                                                    </ng-template>
                                                                    {{ candidate.FirstName }}
                                                                </div>
                                                                <a (click)="DeleteCadidates(candidate.JID)">
                                                                    <i class="fa-solid fa-trash-can" style=" color: darkred;"></i>
                                                                </a>
                                                            </span>
                                                        </div>                                                         
                                                        <!--<h5 class="card-title" style="color: #265ac3; margin-top: -36px;">
                                                            <a (click)="DeleteCadidates(candidate.JID)">
                                                                <i class="fa-solid fa-trash-can" style="margin-left: 100%; color: darkred;"></i>
                                                            </a>
                                                            <img *ngIf="candidate.Photo; else personIcon"
                                                                 [src]="candidate.Photo"
                                                                 style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 8px;">
                                                            <ng-template #personIcon>
                                                                <i class="fas fa-user" style="color: black; margin-right: 8px;"></i>
                                                            </ng-template>
                                                            {{ candidate.FirstName }}
                                                        </h5>--><br />
                                                        <h6 class="card-subtitle mb-2 text-muted">
                                                            <i class="fas fa-briefcase"></i> {{ candidate.Designation }}
                                                        </h6>
                                                        <!--<p class="card-text">
        <i class="fas fa-envelope"></i> <strong>Email:</strong> {{ candidate.Email }}<br>
        <i class="fas fa-graduation-cap"></i> <strong>Qualification:</strong> {{ candidate.Qualification }}<br>
        <i class="fas fa-tools"></i> <strong>Key Skills:</strong> {{ candidate.KeySkills }}<br>
        <i class="fas fa-map-marker-alt"></i> <strong>Current Location:</strong> {{ candidate.CurrentWorkLocation }}<br>
        <i class="fas fa-briefcase"></i> <strong>Experience:</strong> {{ candidate.Experience || 'Not defined' }} years<br>
        <i class="fas fa-money-bill-wave"></i> <strong>Salary:</strong> ₹{{ candidate.Salary || 'Not defined' }}<br>
        <i class="fas fa-hand-holding-usd"></i> <strong>Expected Salary:</strong> ₹{{ candidate.EexpectingSalary || 'Not defined' }}
    </p>-->

                                                        <div class="card-links">

                                                            <!-- Resume Download Button -->

                                                            <a (click)="downloadResume($event,candidate)"
                                                               class="btn btn-primary btn-sm">
                                                                <i class="fas fa-file-download"></i> View
                                                            </a>
                                                            <a *ngIf="HomeURL + candidate.AudioRecord" class="btn btn-info btn-sm" (click)="playAudio(candidate)">
                                                                <i class="fas fa-microphone"></i>Audio
                                                            </a>

                                                            <!-- Video Preview Button -->
                                                            <a *ngIf="HomeURL + candidate.VideoRecord" class="btn btn-secondary btn-sm" (click)="playVideo(candidate)">
                                                                <i class="fas fa-video"></i> Video
                                                            </a>
                                                            <button type="button" class="btn btn-danger btn-sm reject-btn">
                                                                <i class="fas fa-times"></i> Reject
                                                            </button>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <!-- extracontent -->
        <!--<div class="tab__content">
            <div class="row">
                <div class="col-md-2">
                    <div class="vertical-tab" role="tabpanel">
                        <ul class="nav nav-tabs border" role="tablist">
                            <li class="nav-item" role="presentation">
                                <a class="nav-link active   border-0" aria-controls="companyDetail" role="tab">Pending</a>
                            </li>
                            <li class="nav-item" role="presentation">
                                <a class="nav-link border-0 " aria-controls="subscriptionDetail" role="tab" data-bs-toggle="tab">Approved</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-10">
                    <div class="candidate-list" *ngFor="let item of jobdata">
                        <div class="candidate-list-box card">
                            <div class="py-2 mx-0">
                                <div class="align-items-center m-0 row">
                                    <div class="col-auto">
                                        <div class="candidate-list-images" *ngIf="item.Photo">
                                            <img src="{{HomeURL +  item.Photo}} " alt="" class="avatar-md img-thumbnail rounded-circle" />
                                        </div>-->
                                        <!--<div class="candidate-list-images" *ngIf="!item.Photo">
                                            <a href="#"><img src="../assets/img/adam.jpg" alt="" class="avatar-md img-thumbnail rounded-circle" /></a>
                                        </div>-->
                                    <!--</div>
                                    <div class="col-lg-4">
                                        <div class="candidate-list-content mt-3 mt-lg-0">
                                            <p class="text-primary mb-2">{{item.FirstName}}</p>
                                            <ul class="list-inline mb-0 text-black">
                                                <li class="list-inline-item"><i class="mdi mdi-map-marker"></i> {{item.Designation}}</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="col-lg-5 d-flex justify-content-end  ms-4">
                                        <div class="d-flex flex-column align-items-end">-->
                                            <!-- Keep items aligned to the end -->
                                            <!--<div class="d-flex justify-content-end mb-2">-->
                                                <!-- Adjusted margin -->
                                                <!--<button class="btn btn-primary me-3 mb-5 pb-5" (click)="download(item.Resume)">
                                                    <i class="fa-solid fa-download"></i> Download CV
                                                </button>





                                                <span>
                                                    <i class="fa-regular fa-clock"></i> {{ item.CreatedDate | date: 'MMM d, y, h:mm a' }}
                                                </span>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="rounded d-flex justify-content-between align-items-center mt-2">
                                    <ul class="list-unstyled d-flex text-secondary mb-0">
                                        <li class="border p-2 mx-2 rounded-4">{{item.KeySkills}}</li>

                                    </ul>
                                    <button class="btn btn-success rounded-0 widthh me-4">Selected</button>
                                </div>
                            </div>
                        </div>
                        <br />-->


                        <!-- end -->
                    <!--</div>
                </div>
            </div>
        </div>-->
    </div>
</div>
